<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue'
import { useForm, useToast } from 'vuestic-ui'
import { getUserById, updatePassword } from '../../core/requests/Users'

const emit = defineEmits(['close'])

const isLoading = ref(false)
const { isValid, validate } = useForm('formRef')
const form: any = reactive({})
const { notify } = useToast()
const basic = ref([])
const userData: any = ref(null)

const toBase64 = async (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
  })
}

onMounted(() => {
  getData()
})

const doProcess = async () => {
  if (validate()) {
    isLoading.value = true

    try {
      //
      const body: any = {
        password: form.password,
        repassword: form.password2,
      }

      if (basic.value.length) {
        const signFile = await toBase64(basic.value[0])
        body.sign = signFile
      }

      const response: any = await updatePassword(body)

      if (response.status == true) {
        // getData()
        notify({ message: 'Usuario actualizado correctamente', color: 'primary' })
        emit('close')
      } else {
        notify({ message: 'Error al actualizar usuario', color: 'danger' })
      }
    } catch (e: any) {
      console.log(e)
    }

    isLoading.value = false
  }
}

const getData = async () => {
  const _ = localStorage.getItem('__user')
  const _user = _ ? JSON.parse(_) : null

  userData.value = await getUserById(_user.id)
}
</script>

<template>
  <div class="bg-blue-50">
    <div class="mb-4">
      <div class="flex justify-between align-center justify-center">
        <h1 class="h5 font-bold m-0">Detalle de Usuario</h1>
      </div>
    </div>

    <div class="new-customer gap-8">
      <VaForm ref="formRef" immediate class="gap-2">
        <div class="w-full bg-white p-2 pb-5 mb-4">
          <div class="gap-2">
            <div class="columns-1 mt-1">
              <!-- <div class="w-full my-3">
                <VaInput v-model="form.username" disabled stateful clearable label="Usuario" type="email" />
              </div> -->
              <div class="w-full">
                <!-- :rules="[validators.required]" -->
                <VaInput v-model="form.password" stateful clearable type="password" label="Nueva Contraseña" />
              </div>

              <div class="w-full mt-3">
                <VaInput v-model="form.password2" stateful clearable type="password" label="Repite la Contraseña" />
              </div>

              <div class="mb-4">
                <div v-if="userData" class="my-2 mb-4">
                  <p class="mb-2" style="font-size: 11px; font-weight: 600; color: var(--va-primary)">Firma:</p>
                  <img :src="userData.signature" style="width: 120px" alt="" />
                </div>

                <VaFileUpload
                  v-model="basic"
                  dropzone
                  drop-zone-text="Arrastra o selecciona tu firma"
                  upload-button-text="Buscar"
                  file-types="jpg,jpeg,png"
                />
                <p v-if="basic?.length > 1" class="text-xxs bg-red-100 px-2">Solo se admite un archivo.</p>
              </div>
            </div>
          </div>
        </div>
      </VaForm>
    </div>

    <div class="pb-3">
      <div class="flex justify-end">
        <div class="flex gap-2">
          <VaButton
            icon="save"
            color="primary"
            :disabled="!isValid || basic?.length > 1"
            :loading="isLoading"
            @click="doProcess"
          >
            <span class="text-xs px-1">Actualizar Usuario</span>
          </VaButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.new-customer {
  &-tabs {
    .va-tabs__content {
      width: 100%;
    }
  }

  .float-profile {
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
